<template>
  <EeasNavbar />
  <div class="w-100" style="padding-top: 48px; min-height: calc(100vh - 80px);">
    <router-view></router-view>
  </div>
  <EeasFooter />
</template>

<script src="./app.ts" lang="ts">

</script>